export default "__VITE_ASSET__DCcQf8WC__"